import React, { useState, useEffect } from "react";

import { Http } from "../../Http";
import queryString from "query-string";

import { Form, Select, Button, Modal, Upload, message } from "antd";

import styles from "./NewsUpload.module.less";

const FormItem = Form.Item;
const Option = Select.Option;

function NewsUpload({ visible, brand, onRefresh, onClose }) {
  const [submit, setSubmit] = useState(false);
  const [fileList, setFileList] = useState([]);

  const [form] = Form.useForm();

  const uploadProps = {
    accept: ".txt",
    fileList,
    multiple: true,
    beforeUpload: (file, newFileList) => {
      setFileList([...fileList, ...newFileList]);
      return false;
    },
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
  };

  const onFinish = async (values) => {
    if (fileList.length == 0) {
      return message.warn("请至少选择一个文件");
    }
    setSubmit(true);
    try {
      for (let i = 0; i < fileList.length; i++) {
        let file = fileList[i];
        let formData = new FormData();
        formData.append("brandId", brand.id);
        formData.append("file", file);
        let parsed = await Http.post(`news/upload`, {
          body: formData,
        }).json();
        if (parsed.state === "ok") {
          await message.success(parsed.message ? parsed.message : "提交成功");
        } else {
          await message.warn(parsed.message ? parsed.message : "提交失败");
        }
      }
      setFileList([]);
      onClose();
      onRefresh();
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({});
    }
  }, [visible]);

  return (
    <div className={styles.NewsUpload}>
      <Modal
        title="批量上传"
        visible={visible}
        centered={true}
        onOk={() => {
          form.submit();
        }}
        okText="开始上传"
        onCancel={() => {
          onClose();
        }}
        cancelText="关闭"
        confirmLoading={submit}
        destroyOnClose={true}
      >
        <Form
          preserve={false}
          form={form}
          onFinish={onFinish}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <FormItem label="上传">
            <Upload {...uploadProps}>
              <Button>选择文件</Button>
            </Upload>
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default NewsUpload;
